<template lang="pug">
.pa-3
  //- usuarios-involucrados(:numero="numero" v-if="actividades.length")
  v-timeline(:dense='$vuetify.breakpoint.smAndDown', v-if="actividades.length")
    v-timeline-item.animated.faster.pb-3(
      v-for="(o, index) in actividades"
      :key="index + o",
      small,
      :right="o.origen === '' || o.origen === null "
      :left="o.origen === 'empresa'"
    )
      span(slot="opposite", v-if="!isMovil")
        small.font-size-11.text-muted {{o.fechaLegible}}
      item-time-line(:actividad="o", @update="fetchActividades"  :group="o.group")
  div(v-for="a in 5", v-else)
    v-row
      v-col.pa-0(cols="12" md='6')
        v-skeleton-loader(type='list-item-avatar-two-line', max-width="350")
      v-col.pa-0(cols="12" md='6')
    v-row
      v-col.pa-0(cols="12" md='6')
      v-col.pa-0(cols="12" md='6')
        v-skeleton-loader(type='list-item-avatar-three-line', max-width="350")
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { apiGet, notify } from '../util/general'
import usuariosInvolucrados from '@/components/c_usuarios_involucrados_ticket'
import itemTimeLine from '@/components/c_item_timeline'
export default {
  name : 'c_timeline_actividades_ticket',
  components: {
    'usuarios-involucrados': usuariosInvolucrados,
    'item-time-line'       : itemTimeLine
  },
  props: ['numero'],
  data () {
    return {
      actividades  : [],
      isLoading : false
    }
  },
  created () {
    var vm = this
    vm.fetchActividades()
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    textIsURL (text) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return pattern.test(text)
    },
    fetchActividades (isLoading = false) {
      var vm = this
      console.log('fetch actividades.........................')
      if (isLoading) vm.actividades = []
      // vm.isLoading = isLoading
      vm.$store.dispatch('transaccion', {isProceso : true, message : 'Obteniendo actividades'})
      var obj = { }
      apiGet(vm, '/ticket/' + vm.numero + '/actividades', obj, function (data) {
        var actividadesConsolidado = []
        for (var i = 0; i < data.actividades.length; i++) {
          var e = data.actividades[i];
          if (e.tipo === 'adjunto' && e.tipoAdjunto.includes('image') && !e.oculto) {
            var fechaActividad = moment(e.fecha).format('DD/MM/YYYY HH:mm')
            var similares      = []
            data.actividades.forEach(ac => {
              if (
                ac.tipo === 'adjunto' &&
                ac.tipoAdjunto.includes('image') &&
                fechaActividad === moment(ac.fecha).format('DD/MM/YYYY HH:mm') &&
                ac.origen === e.origen &&
                !ac.oculto
              ) {
                similares.push(ac)
              }
            })
            if (similares.length > 1) {
              var size = similares.length

              actividadesConsolidado.push({
                group       : true,
                imagenes    : similares,
                origen      : similares[0].origen,
                tipoAdjunto : similares[0].tipoAdjunto,
                fechaLegible: similares[0].fechaLegible,
                render1     : size >= 1,
                render2     : size >= 2,
                render3     : size >= 3,
                render4     : size >= 4,
                countMore   : size > 4 ? size - 4   : 0,
                tipo        : 'adjunto',
                nombre      : similares[0].nombre,
                cargo       : similares[0].cargo,
                accion      : `Ha adjutado ${size} imagenes`
              })
            } else {
              actividadesConsolidado.push({group : false, ...e})
            }
          } else {
            actividadesConsolidado.push({group : false, ...e})
          }
        }

        vm.actividades = _.uniqWith(actividadesConsolidado, _.isEqual);
        vm.$emit('updated', vm.actividades[0].fecha)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
        // vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_timeline_actividades_ticket.vue?3f188c4c